// src/scripts/templates/warranty-claim.ts
var form = document.getElementById("claim-form");
var submitButton = document.getElementById("submit-button");
var formTitle = document.getElementById("form-title");
var CLAIM_ENDPOINT = "https://nood-co-api.onrender.com/api/claim";
function showError() {
  const errorElement = document.getElementById("error-message");
  submitButton.innerHTML = "Submit Claim";
  submitButton.setAttribute("disabled", "false");
  errorElement.classList.remove("hidden");
}
function showSuccess() {
  const successElement = document.getElementById("success-message");
  submitButton.innerHTML = "Submit Claim";
  submitButton.setAttribute("disabled", "false");
  successElement.classList.remove("hidden");
  formTitle.classList.add("hidden");
  form.classList.add("hidden");
}
form.addEventListener("submit", async (e) => {
  e.preventDefault();
  try {
    const body = new FormData(form);
    submitButton.innerHTML = "Submitting...";
    submitButton.setAttribute("disabled", "true");
    const response = await fetch(CLAIM_ENDPOINT, { method: "POST", body });
    const { error, success } = await response.json();
    if (!success)
      throw new Error(error);
    showSuccess();
  } catch (error) {
    showError();
    submitButton.innerHTML = "Send Claim";
  }
});
